import { QueryEntity } from '@datorama/akita';
import { PreCheckoutStore } from './pre-checkout.store';
import { PreCheckoutState } from './pre-checkout.model';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PreCheckoutQuery extends QueryEntity<PreCheckoutState> {

  cpf$: Observable<string> = this.select(state => state.cpf);
  name$: Observable<string> = this.select(state => state.name);
  phone$: Observable<string> = this.select(state => state.phone);
  route$: Observable<string> = this.select(state => state.route);
  sm$: Observable<string> = this.select(state => state.sm);
  originCd$: Observable<string> = this.select(state => state.originCd);
  destinoCd$: Observable<string> = this.select(state => state.destinoCd);
  transporter$: Observable<string> = this.select(state => state.transporter);
  transporterType$: Observable<string> = this.select(state => state.transporterType);
  hash$: Observable<string> = this.select(state => state.hash);
  plates$: Observable<Array<any>> = this.select(state => state.plates);
  stageLogin$: Observable<boolean> = this.select(state => state.stageLogin);
  stageViagem$: Observable<boolean> = this.select(state => state.stageViagem);
  stageVeiculo$: Observable<boolean> = this.select(state => state.stageVeiculo);

  constructor(protected store: PreCheckoutStore) {
    super(store);
  }
}